import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountingSystemEntityConfig  {
    _originalTypeClassName = "zERP.BO.AccountingSystemEntityConfig";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountingSystemEntityConfig.translate = translateService;
}
this.Items = [];
this.CreatedAccounts = [];
this.RuleMappings = [];
this.Categories = [];
this.Id = null;
this.AccountSelectionType = null;
this.MaxLevel = null;
this.NotTerminalName = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
AccountSelectionType:any;
MaxLevel:any;
NotTerminalName:any;
Items:any;
CreatedAccounts:any;
RuleMappings:any;
Categories:any;
static setItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.Items == null) $this.Items = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Items.length > 0) {
                    Domain.AccountingSystemEntityConfig.removeItems($this, $this.Items[0]);
                }

                Domain.AccountingSystemEntityConfig.addManyItems($this, copyItems);
            }
static addManyItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountingSystemEntityConfig.addItems($this, items[i]);
                }
            }
static addItems = ($this, item) => {
                if ($this.Items == null) $this.Items = [];
                if (item == null || $this.Items.indexOf(item) > -1) return;
                $this.Items.push(item);
}
static addRangeItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountingSystemEntityConfig.addItems($this, item));
            }
static removeItems = ($this, item) => {
                if ($this == null || $this.Items == null || $this.Items.indexOf(item) === -1) return;
                var _index = $this.Items.indexOf(item);
                $this.Items.splice(_index, 1);
}
static clearItems = ($this) => { $this.Items = null; }
static setCreatedAccounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.CreatedAccounts == null) $this.CreatedAccounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.CreatedAccounts.length > 0) {
                    Domain.AccountingSystemEntityConfig.removeCreatedAccounts($this, $this.CreatedAccounts[0]);
                }

                Domain.AccountingSystemEntityConfig.addManyCreatedAccounts($this, copyItems);
            }
static addManyCreatedAccounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountingSystemEntityConfig.addCreatedAccounts($this, items[i]);
                }
            }
static addCreatedAccounts = ($this, item) => {
                if ($this.CreatedAccounts == null) $this.CreatedAccounts = [];
                if (item == null || $this.CreatedAccounts.indexOf(item) > -1) return;
                $this.CreatedAccounts.push(item);
}
static addRangeCreatedAccounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountingSystemEntityConfig.addCreatedAccounts($this, item));
            }
static removeCreatedAccounts = ($this, item) => {
                if ($this == null || $this.CreatedAccounts == null || $this.CreatedAccounts.indexOf(item) === -1) return;
                var _index = $this.CreatedAccounts.indexOf(item);
                $this.CreatedAccounts.splice(_index, 1);
}
static clearCreatedAccounts = ($this) => { $this.CreatedAccounts = null; }
static setRuleMappings = ($this, items) => {
                if (items == null) items = [];
                if ($this.RuleMappings == null) $this.RuleMappings = [];

                const copyItems = Common.cloneObject(items);

                while ($this.RuleMappings.length > 0) {
                    Domain.AccountingSystemEntityConfig.removeRuleMappings($this, $this.RuleMappings[0]);
                }

                Domain.AccountingSystemEntityConfig.addManyRuleMappings($this, copyItems);
            }
static addManyRuleMappings = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountingSystemEntityConfig.addRuleMappings($this, items[i]);
                }
            }
static addRuleMappings = ($this, item) => {
                if ($this.RuleMappings == null) $this.RuleMappings = [];
                if (item == null || $this.RuleMappings.indexOf(item) > -1) return;
                $this.RuleMappings.push(item);
}
static addRangeRuleMappings = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountingSystemEntityConfig.addRuleMappings($this, item));
            }
static removeRuleMappings = ($this, item) => {
                if ($this == null || $this.RuleMappings == null || $this.RuleMappings.indexOf(item) === -1) return;
                var _index = $this.RuleMappings.indexOf(item);
                $this.RuleMappings.splice(_index, 1);
}
static clearRuleMappings = ($this) => { $this.RuleMappings = null; }
static setCategories = ($this, items) => {
                if (items == null) items = [];
                if ($this.Categories == null) $this.Categories = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Categories.length > 0) {
                    Domain.AccountingSystemEntityConfig.removeCategories($this, $this.Categories[0]);
                }

                Domain.AccountingSystemEntityConfig.addManyCategories($this, copyItems);
            }
static addManyCategories = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountingSystemEntityConfig.addCategories($this, items[i]);
                }
            }
static addCategories = ($this, item) => {
                if ($this.Categories == null) $this.Categories = [];
                if (item == null || $this.Categories.indexOf(item) > -1) return;
                $this.Categories.push(item);
}
static addRangeCategories = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountingSystemEntityConfig.addCategories($this, item));
            }
static removeCategories = ($this, item) => {
                if ($this == null || $this.Categories == null || $this.Categories.indexOf(item) === -1) return;
                var _index = $this.Categories.indexOf(item);
                $this.Categories.splice(_index, 1);
}
static clearCategories = ($this) => { $this.Categories = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}